import { render } from "./AssociaLimits.vue?vue&type=template&id=3f5166aa"
import script from "./AssociaLimits.vue?vue&type=script&lang=js"
export * from "./AssociaLimits.vue?vue&type=script&lang=js"

import "./AssociaLimits.vue?vue&type=style&index=0&id=3f5166aa&lang=scss"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__